import { StorageOfUniqueServices } from '@qality/common-service';

export default {
  createErrorFlag(title: string, body: string): void {
    this.createFlag(title, body, 'error');
  },

  createSuccessFlag(title: string, body: string): void {
    this.createFlag(title, body, 'success');
  },

  createInfoFlag(title: string, body: string): void {
    this.createFlag(title, body, 'info');
  },

  createWarningFlag(title: string, body: string): void {
    this.createFlag(title, body, 'warning');
  },

  createFlag(
    title: string,
    body: string,
    type: 'success' | 'info' | 'warning' | 'error',
    actions?: Record<string, string>
  ): void {
    StorageOfUniqueServices.get('AP').flag.create({
      title: title,
      body: body,
      type: type,
      close: 'auto',
      actions: actions ? actions : null, // TODO: check if we can't pass just actions
    });
  },

  async createControlledFlag(
    title: string,
    body: string,
    type: 'success' | 'info' | 'warning' | 'error',
    time: number,
    actions?: Record<string, string>
  ): Promise<void> {
    const flagObject = {
      title: title,
      body: body,
      type: type,
      close: 'manual',
      actions: actions ? actions : null,
    };

    const flag = StorageOfUniqueServices.get('AP').flag.create(flagObject);

    setTimeout(
      (flagParam) => {
        flagParam.close();
      },
      time,
      flag
    );
  },
};
